module.exports = __webpack_public_path__ + "static/media/qa.6b0bfc63.svg";